/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'SAFETY_COMMITTEE_MEETINGS_ARE_HELD_ON_A_MONTHLY_BASIS',
              'SAFETY_COMMITTEE_MEETINGS_ARE_HELD_AT_LEAST_QUARTERLY',
              'SAFETY_COMMITTEE_MEETING_MINUTES_ARE_SHARED_WITH_THE_WORKFORCE',
              'SAFETY_COMMITTEE_MEETING_ACTION_ITEMS_ARE_TRACKED',
              'SAFETY_COMMITTEE_COMMUNICATES_COMPLAINTS_AND_PROBLEMS_SHARED_BY',
              'UPPER_MANAGEMENT_RECOGNIZES_ACCEPTS_THE_SAFETY_COMMITTEE',
              'SAFETY_COMMITTEE_MEETS_TO_REVIEW_SAFETY_ISSUES_TRACK_CORRECTIVE',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_observe_any_of_the_following_practices_related_to_1: valueSchema,
  },
}
